import SearchPage from '../../pages/search'
import createSearchPageContainer from './createSearchPageContainer'

export default createSearchPageContainer(SearchPage)
